export default __webpack_public_path__ + "static/media/high_res_work_area.ec0666b8.webp";